/* global window */

import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { removeFormError, setScrollTopOff } from 'redux/formErrors/actions';

class FormError extends Component {
  componentDidMount() {
    const { props } = this;
    // On location change - remove form errors
    props.history.listen(() => {
      props.removeFormError();
    });
  }

  componentDidUpdate() {
    const { props } = this;
    if (this.errorNode && props.scrollTop) {
      this.errorNode.scrollIntoView();
      this.errorNode.setAttribute('tabIndex', -1);
      this.errorNode.focus();
      window.scrollBy(0, -150);
      props.setScrollTopOff();
    }
  }

  render() {
    const { formError, form } = this.props;
    // If we dont have form errors
    if (!formError) {
      return null;
    }

    if (!form) {
      return null;
    }

    return (
      <div
        className="c7-message--error"
        ref={(div) => {
          this.errorNode = div;
        }}
      >
        Error: Please fix the form errors below.
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const { formName } = props;
  return {
    formError: state.formError.formError,
    scrollTop: state.formError.scrollTop,
    form: formName && state.form[formName] && state.form[formName].fields
  };
};

export default withRouter(
  connect(mapStateToProps, { removeFormError, setScrollTopOff })(FormError)
);
